import axios from "./axios";
import Axios from "axios";

/**
 * Upload files using the same presigned-url flow as UploaderV4.
 * @param {string} module - e.g. "hour"
 * @param {string|number} moduleParam - target id
 * @param {File[]} files
 * @returns {Promise<object[]>} Uploaded document payloads from complete_upload
 */
export async function uploadModuleDocuments(module, moduleParam, files) {
  const idNum =
    typeof moduleParam === "number"
      ? moduleParam
      : parseInt(String(moduleParam == null ? "" : moduleParam).trim(), 10);
  if (!Number.isFinite(idNum) || idNum <= 0) {
    throw new Error("Invalid module parameter for document upload");
  }
  const mp = String(Math.trunc(idNum));
  const uploaded = [];

  for (const file of files) {
    const title = file.name.replace(/\.[^/.]+$/, "");
    const presigned = await axios.get("/uploads/presigned_url", {
      params: {
        filename: file.name,
        module,
        module_param: mp,
        title,
      },
    });

    const { url, document_id } = presigned.data || {};
    if (!url || !document_id) {
      throw new Error("Invalid presigned URL response");
    }

    await Axios.put(url, file, {
      headers: { "Content-Type": file.type || "application/octet-stream" },
    });

    const fileResponse = await axios.patch("/uploads/complete_upload", {
      id: document_id,
      filename: file.name,
      title,
      module,
      module_param: mp,
      folder_id: null,
      drawing_id: null,
      drawing_position_x: null,
      drawing_position_y: null,
      drawing_rotation: 0,
    });

    const doc =
      fileResponse.data?.document != null ? fileResponse.data.document : fileResponse.data;
    if (doc) uploaded.push(doc);
  }

  return uploaded;
}
